<div class="add-endpoints" [formGroup]="addEndpointsFormGroup">
  <app-popup-top-line></app-popup-top-line>
  <div class="add-endpoints-header">
    <div class="title">
      {{ 'policyPage.config.endpointFilteringContent.addEndpoint' | labelsProvider }}
    </div>
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose()" />
  </div>
  <div class="add-endpoints-body" formArrayName="endpointsToAdd">
    <div class="section-title" *ngIf="endpointsToAdd.length > 0">New Endpoints to Add</div>
    <div class="add-endpoints-body-description">
      {{ 'policyPage.config.endpointFilteringContent.addEndpointsDescription' | labelsProvider }}
    </div>

    @for (control of endpointsToAdd.controls; track control; let i = $index) {
      <div class="endpoint-input-container" [formGroupName]="i">
        <div
          class="input"
          [class.input-invalid]="control.get('url')?.errors?.['duplicate'] && control.get('url')?.touched"
        >
          <input
            type="text"
            formControlName="url"
            placeholder="{{ 'policyPage.config.endpointFilteringContent.enterEndpoint' | labelsProvider }}"
          />
          @if (i > 0) {
            <img src="assets/images/common/cancel.svg" (click)="removeEndpoint(i)" />
          }
        </div>
        @if (control.get('url')?.errors?.['duplicate'] && control.get('url')?.touched) {
          <div class="error-message">This endpoint already exists in the policy</div>
        } @else if (control.get('url')?.errors && control.get('url')?.touched && control.get('url')?.value) {
          <div class="error-message">
            {{ 'policyPage.config.endpointFilteringContent.invalidEndpoint' | labelsProvider }}
          </div>
        }
      </div>
    }

    @if (endpointsToAdd.touched && endpointsToAdd.invalid && endpointsToAdd.errors) {
      <div class="error-message">
        {{ 'policyPage.config.endpointFilteringContent.enterUniqueEndpointsMsg' | labelsProvider }}
      </div>
    }

    <div class="add-endpoints-actions">
      @if (endpointsToAdd.controls.length < maxHostnamesToAdd) {
        <div class="add-more" (click)="addMoreClicked()">
          <img class="add-more-img" src="assets/images/common/plus.svg" />
          <div class="add-endpoints-button-title">
            {{ 'policyPage.config.endpointFilteringContent.addMore' | labelsProvider }}
          </div>
        </div>
      }

      <div class="bulk-upload" (click)="triggerFileUpload()" [class.disabled]="processingFile()">
        <img class="bulk-upload-img" src="assets/images/common/import.svg" />
        <div class="add-endpoints-button-title">
          {{ processingFile() ? 'Processing...' : 'Bulk Upload' }}
        </div>
      </div>
    </div>

    <div class="bulk-upload-help">
      Upload a CSV file with endpoints (one per line or in the first column, up to 2000 endpoints per file)
    </div>

    <!-- Skipped endpoints section -->
    @if (skippedEndpoints().length > 0) {
      <div class="skipped-endpoints-section">
        <div class="skipped-endpoints-header" (click)="toggleSkippedEndpoints()">
          <img
            class="expand-icon"
            [src]="
              showSkippedEndpoints()
                ? 'assets/images/common/collapse-nodes.svg'
                : 'assets/images/common/expand-nodes.svg'
            "
          />
          <span class="skipped-title">
            {{ skippedEndpoints().length }} endpoint{{ skippedEndpoints().length > 1 ? 's' : '' }} already exist (click
            to {{ showSkippedEndpoints() ? 'hide' : 'show' }})
          </span>
        </div>
        @if (showSkippedEndpoints()) {
          <div class="skipped-endpoints-list">
            @for (endpoint of skippedEndpoints(); track endpoint) {
              <div class="skipped-endpoint">{{ endpoint }}</div>
            }
          </div>
        }
      </div>
    }

    <!-- Invalid endpoints section -->
    @if (invalidEndpoints().length > 0) {
      <div class="invalid-endpoints-section">
        <div class="invalid-endpoints-header" (click)="toggleInvalidEndpoints()">
          <img
            class="expand-icon"
            [src]="
              showInvalidEndpoints()
                ? 'assets/images/common/collapse-nodes.svg'
                : 'assets/images/common/expand-nodes.svg'
            "
          />
          <span class="invalid-title">
            {{ invalidEndpoints().length }} invalid endpoint{{ invalidEndpoints().length > 1 ? 's' : '' }} (click to
            {{ showInvalidEndpoints() ? 'hide' : 'show' }})
          </span>
        </div>
        @if (showInvalidEndpoints()) {
          <div class="invalid-endpoints-list">
            @for (endpoint of invalidEndpoints(); track endpoint) {
              <div class="invalid-endpoint">{{ endpoint }}</div>
            }
          </div>
        }
      </div>
    }

    <input #csvFileInput type="file" accept=".csv" style="display: none" (change)="onFileSelected($event)" />
  </div>
  <div class="add-endpoints-footer">
    <button class="cancel" (click)="onClose()">
      {{ 'common.cancel' | labelsProvider }}
    </button>
    <button
      class="confirm"
      [ngClass]="{ 'confirm-disabled': addEndpointsFormGroup.invalid || waitingForResponse }"
      (click)="addEndpoint()"
      cdkFocusInitial
    >
      @if (!waitingForResponse) {
        <span>{{ 'common.add' | labelsProvider }}</span>
      }
      @if (waitingForResponse) {
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"></mat-progress-spinner>
      }
    </button>
  </div>
</div>
